
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from './components/ui/toaster';
import NotFound from './pages/NotFound';
import ServerError from './pages/ServerError';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';

import Brochures from './pages/Brochures';
import AdminBrochures from './pages/AdminBrochures';
import AdminBulletin from './pages/AdminBulletin';
import AdminQuickOne from './pages/AdminQuickOne';
import AdminLogin from './pages/AdminLogin';
import ResetPassword from './pages/ResetPassword';
import CorporateGovernanceTech from './pages/CorporateGovernanceTech';
import ArbitrationADR from './pages/ArbitrationADR';
import FounderProfile from './pages/FounderProfile';
import TeamProfile from './pages/TeamProfile';
import GraceGakii from './pages/partners/GraceGakii';
import DerrickOuma from './pages/partners/DerrickOuma';
import Mentorship from './pages/Mentorship';
import Contact from './pages/Contact';
import MentorshipApplication from './pages/MentorshipApplication';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DataPrivacyLaw from './pages/commentary/DataPrivacyLaw';
import CybersecurityLaw from './pages/commentary/CybersecurityLaw';
import AILaw from './pages/commentary/AILaw';
import IntellectualPropertyLaw from './pages/commentary/IntellectualPropertyLaw';
import CompetitionLaw from './pages/commentary/CompetitionLaw';
import ConsumerProtection from './pages/commentary/ConsumerProtection';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1">
          <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/ai-law-ethics" element={<Navigate to="/brochures" replace />} />
            <Route path="/brochures" element={<Brochures />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin/brochures" element={<AdminBrochures />} />
            <Route path="/admin/bulletin" element={<AdminBulletin />} />
            <Route path="/admin/quick-one" element={<AdminQuickOne />} />
            <Route path="/corporate-governance-tech" element={<CorporateGovernanceTech />} />
            <Route path="/arbitration-adr" element={<ArbitrationADR />} />
            <Route path="/founder-profile" element={<FounderProfile />} />
            <Route path="/team-profile" element={<TeamProfile />} />
            <Route path="/partners/grace-gakii" element={<GraceGakii />} />
            <Route path="/partners/derrick-ouma" element={<DerrickOuma />} />
            <Route path="/mentorship" element={<Mentorship />} />
            <Route path="/mentorship-application" element={<MentorshipApplication />} />
            <Route path="/commentary/data-privacy-law" element={<DataPrivacyLaw />} />
            <Route path="/commentary/cybersecurity-law" element={<CybersecurityLaw />} />
            <Route path="/commentary/ai-law" element={<AILaw />} />
            <Route path="/commentary/intellectual-property-law" element={<IntellectualPropertyLaw />} />
            <Route path="/commentary/competition-law" element={<CompetitionLaw />} />
            <Route path="/commentary/consumer-protection" element={<ConsumerProtection />} />
            <Route path="/sectors/machine-learning" element={<Navigate to="/commentary/ai-law" replace />} />
            <Route path="/sectors/agentic-ai" element={<Navigate to="/commentary/ai-law" replace />} />
            <Route path="/sectors/generative-ai" element={<Navigate to="/commentary/ai-law" replace />} />
            <Route path="/sectors/computer-vision" element={<Navigate to="/commentary/ai-law" replace />} />
            <Route path="/sectors/nlp-privacy" element={<Navigate to="/commentary/data-privacy-law" replace />} />
            <Route path="/sectors/robotics-legal" element={<Navigate to="/commentary/ai-law" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/500" element={<ServerError />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </ErrorBoundary>
        </main>
        
        <Footer />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
